import React from "react";
import "./Table.scss";
import { Table } from "react-bootstrap";
import { useSwapContext } from "context/swap-context";
import {
  formatUTC,
  getTransactionUrl,
  getTruncatedAddress,
  twoDecimalPlaces,
} from "utils/helper";

const TransactionHistory = () => {
  const { userTrxData } = useSwapContext();

  return (
    <div className="transactionTbl">
      <div className="table-name">Transaction History</div>
      <div className="tbl-wrapper">
        <Table responsive>
          <thead>
            <tr>
              <th style={{ width: '33.33%' }}>Date</th>
              <th style={{ width: '33.33%' }}>Amount</th>
              {/* <th>From</th> */}
              {/* <th>To</th> */}
              <th style={{ width: '33.33%' }}>Transaction ID</th>
            </tr>
          </thead>
          <tbody>
            {userTrxData?.length > 0 ? (
              userTrxData.map((data, i) => {
                return (
                  <tr key={`Transaction${i + 1}`}>
                    <td>{formatUTC(data.date)}</td>
                    <td>{twoDecimalPlaces(data.tvk)}</td>
                    {/* <td>{getTruncatedAddress(data.from)}</td> */}
                    {/* <td>{getTruncatedAddress(data.to)}</td> */}
                    <td>
                      <a
                        href={getTransactionUrl(data.txId, data.chainId)}
                        rel="noreferrer"
                        style={{ textDecoration: "underline" }}
                      >
                        {getTruncatedAddress(data.txId)}
                      </a>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={8}>
                  <p className="no-data">No Transaction Found</p>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default TransactionHistory;
